import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { ReceiptTrackingForm } from "../components/ReceiptTrackingForm";
import { ReceiptTrackingTable } from "../components/ReceiptTrackingTable";


export const ReceiptTracking = () => {

  const subheader = useSubheader();
  subheader.setTitle("Receipt Tracking");
  
  return (
    <>
      <div className="row">
        <div className="col-12">
          <Switch>
            <Redirect
              from="/receipt-tracking"
              exact={true}
              to="/receipt-tracking/receipt-tracking-table"
            />
            <Route
              path="/receipt-tracking/receipt-tracking-table"
              component={ReceiptTrackingTable}
            />
            <Route
              path="/receipt-tracking/receipt-tracking-form"
              component={ReceiptTrackingForm}
            />
          </Switch>
      </div>
      </div>
    </>
  );
};
